export default "__VITE_ASSET__88fc1b7d__"